import Config  from './config'
import Mapping from './mapping'

import { isString, isArray, hasProp } from 'vessel/utils'

const sideAliases = { t: 'top', r: 'right', b: 'bottom', l: 'left', x: 'horizontal', y: 'vertical' }
const screenSizes = Object.keys(Config.screens)
const modulesData = parseMapping(Mapping)

function parseMapping(mapping) {
  const object = {}

  Object.entries(mapping).forEach(([group, groupOptions]) => {
    let moduleOptions = Config.modules[groupOptions.module]

    if (moduleOptions && moduleOptions !== false) {
      const options = parseGroup(group, groupOptions, moduleOptions)
      const config  = options.config

      object[group] = options

      if (config.sides) {
        let variants = ['Top', 'Right', 'Bottom', 'Left']
        Object.assign(object, parseVariants(group, variants, options))
      }

      if (config.axes) {
        let variants = ['X', 'Y']
        Object.assign(object, parseVariants(group, variants, options))
      }

      if (config.corners) {
        let variants = ['TopLeft', 'TopRight', 'BottomLeft', 'BottomRight']
        Object.assign(object, parseVariants(group, variants, options))
      }
    }
  })

  return object
}

function parseGroup(name, options, module) {
  let groupItem = {
    prefix:  options.prefix,
    config:  parseConfig(options.config),
    values:  parseValues(options.values, name),
    coerce:  options.coerce || (val => val),
    states:  ['normal'],
    screens: ['all']
  }

  module.forEach(option => {
    if (option == 'responsive')
      groupItem.screens.push(...screenSizes)
    else
      groupItem.states.push(option)
  })

  return groupItem
}

function parseVariants(name, variants, options) {
  return variants.reduce((result, variant) => {
    let module = `${name}${variant}`
    let short  = variant.match(/[A-Z]/g).join('').toLowerCase()
    let prefix = options.prefix.replace('-', '')

    if (name.startsWith('border')) {
      let suffix = name.replace('border', '')
      module = `border${variant}${suffix}`
    }

    if (prefix.length > 1)
      prefix = `${options.prefix}-${short}`
    else
      prefix = `${options.prefix}${short}`

    const config = {
      prefix: prefix,
      config: { multiple: false },
      values: { ...options.values },
      coerce: options.coerce || (val => val),
      variantFor: name
    }

    if (name == 'pin') {
      config.prefix = options.prefix
      config.values = { true: options.values[short], false: null }
    }

    result[module] = config

    options.variants = options.variants || {}
    options.variants[short] = module

    return result
  }, {})
}

function parseConfig(values) {
  const config  = values || {}
  const options = ['sides', 'axes', 'corners', 'multiple']

  return options.reduce((result, option) => {
    result[option] = config[option] == true
    return result
  }, {})
}

function parseValues(options, module) {
  let values = options

  if (isString(values))
    values = Object.keys(Config[values])

  if (isArray(values))
    values = valuesObject(values)

  Object.entries(sideAliases).forEach(([name, alias]) => {
    if (hasProp(name, values))
      values[alias] = name
  })

  if (module == 'borderWidth')
    values[1] = values.true

  if (hasProp(module, Config.aliases))
    values = { ...Config.aliases[module], ...values }

  return values
}

function valuesObject(values) {
  const object = {}

  values.forEach(item => {
    let key = item

    if (item == 'default') key = true
    if (item == 'none')    key = false

    object[key] = item
  })

  return object
}

export default modulesData
